import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ICategory, INeighBourhood, ISearchBarData } from '../../state/api/types';
import { categories, neighbourhoods } from '../../utils/fakeData';
import Presenter from './Presenter';
import { IContainerProps } from './types';
import actions from '../../state/actions';
import moment from 'moment';
import 'moment/locale/es';

const HomeContainer = (props: IContainerProps) => {
    const dispatch = useDispatch();
    const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(false);
    const [formData, setFormData] = useState<ISearchBarData>(DEFAULT_FORM_VALUE);
    const [selectedCategories, setSelectedCategories] = useState<ICategory[]>([]);
    // Categories
    const [searchResults, setSearchResults] = useState<ICategory[]>(categories);
    const [isCategoriesBoxVisible, setCategoriesBoxVisibility] = useState(false);
    const toggleCategoriesBoxVisibility = (state?: boolean) => setCategoriesBoxVisibility(state ?? !isCategoriesBoxVisible);
    // Date
    const [isDatePickerVisible, setDatePickerVisibility] = useState(false);
    const toggleDatePickerVisibility = (state?: boolean) => setDatePickerVisibility(state ?? !isDatePickerVisible);
    const [selectedDate, setSelectedDate] = useState<Date | undefined>();
    const handleSelectDate = (date?: Date) => {
        setFormData({ ...formData, date: moment(date).locale('es').format('DD MMMM') ?? '' });
        setSelectedDate(date);
        setCategoriesBoxVisibility(false);
    };
    // Location
    const [searchHoodResults, setSearchHoodResults] = useState<INeighBourhood[]>(categories);
    const [isLocationBoxVisible, setLocationBoxVisibility] = useState(false);
    const toggleLocationBoxVisibility = (state?: boolean) => setLocationBoxVisibility(state ?? !isLocationBoxVisible);

    // Load businesses on mount - CRITICAL FIX for search functionality and empty sections
    useEffect(() => {
        dispatch(actions.api.getBusinesses());
    }, [dispatch]);

    useEffect(() => {
        searchBusinessCategories();
    }, [formData.business]);

    useEffect(() => {
        searchLocations();
    }, [formData.location]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
        let inputData = e.target.value;
        setFormData({ ...formData, [type]: inputData });
    };

    const searchBusinessCategories = () => {
        if (formData.business.length > 0) {
            let _results = categories.filter(category => category.name.toUpperCase().includes(formData.business.toUpperCase()));
            setSearchResults(_results);
            // dispatch(actions.api.mainSearchSuggestRequest(searchBarValue, 'DESC', 7, resultsSearchSuggest));
        } else {
            setSearchResults(categories);
        }
    }

    const addCategory = (category: ICategory) => {
        if (!selectedCategories.find(c => c.id === category.id)) {
            setSelectedCategories([...selectedCategories, category]);
        }
    }

    const removeCategory = (category: ICategory) => {
        setSelectedCategories(selectedCategories.filter(c => c.id !== category.id));
    }

    const searchLocations = () => {
        if (formData.location.length > 0) {
            let _results = neighbourhoods.filter(item => item.name.toUpperCase().includes(formData.location.toUpperCase()));
            setSearchHoodResults(_results);
            // dispatch(actions.api.mainSearchSuggestRequest(searchBarValue, 'DESC', 7, resultsSearchSuggest));
        } else {
            setSearchHoodResults(neighbourhoods);
        }
    }

    const selectLocation = (location: INeighBourhood) => {
        setFormData({ ...formData, location: location.name });
        setLocationBoxVisibility(false);
    }

    return (
        <Presenter
            {...props}
            formData={formData}
            onChange={onChange}
            isBtnDisabled={isBtnDisabled}
            toggleCategoriesBoxVisibility={toggleCategoriesBoxVisibility}
            searchResults={searchResults}
            isCategoriesBoxVisible={isCategoriesBoxVisible}
            searchBusinessCategories={searchBusinessCategories}
            addCategory={addCategory}
            selectedCategories={selectedCategories}
            removeCategory={removeCategory}
            isDatePickerVisible={isDatePickerVisible}
            toggleDatePickerVisibility={toggleDatePickerVisibility}
            selectedDate={selectedDate}
            handleSelectDate={handleSelectDate}
            isLocationBoxVisible={isLocationBoxVisible}
            toggleLocationBoxVisibility={toggleLocationBoxVisibility}
            searchLocations={searchLocations}
            searchHoodResults={searchHoodResults}
            selectLocation={selectLocation}
        />
    );
};

const DEFAULT_FORM_VALUE: ISearchBarData = {
    business: '',
    date: '',
    location: '',
};

export default HomeContainer;
